import { render, staticRenderFns } from "./ToggleRating.vue?vue&type=template&id=0073cac6&scoped=true"
import script from "./ToggleRating.vue?vue&type=script&lang=js"
export * from "./ToggleRating.vue?vue&type=script&lang=js"
import style0 from "./ToggleRating.vue?vue&type=style&index=0&id=0073cac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0073cac6",
  null
  
)

export default component.exports